exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#info-box{width:340px;height:100%;position:absolute;z-index:0;background-color:#fff;right:0;bottom:0;border-left:1px solid #000}#info-box.disable{width:45px}#info-box.disable .content{display:none}#info-box .bar{float:left;width:40px;position:absolute;height:100%;background-color:#000;color:#fff;text-align:center}#info-box .bar .arrow{margin-top:15px;font-size:25px}#info-box .content{float:left;padding-left:40px;position:static;height:100%}#info-box .title{margin-top:15px;background-color:#f9f9f9;text-align:center;padding:10px}#info-box .body{padding:15px;text-align:justify}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-5dae05ca!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DataTableInfoBox.vue
// module id = 897
// module chunks = 2